import React, { Component } from 'react';

//Custom Components
import Header from '../components/Header'
import SingleAppShowCase from '../components/SingleAppShowcase'
import Hero from '../components/Hero'

//Hero
import midwesternHero from '../img/optimized/midwestern_hero.webp'

// Images for Demo
import camoflix from '../img/camoflix-screenshot.png'
import demo from '../img/linerfinder-screenshot.png'
import selahsc from '../img/selah-screenshot.png'

// Images for Logo
import camoflixLogo from '../img/camo-text-icon.png'
import linerFinderLogo from '../img/liner-finder-logo.png'
import SELAHLogo from '../img/logo-selah-white.png'


class Midwestern extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    return (
      <div
        className="align-items-center midwestern-background"
      >
      <Header
        title="Midwestern"
        backgroundColor={'#FFF'}
        textColor={'#000'}
        jobTitle={'Mobile Application Developer'}
        yearsAtRole={"2017-2019"}
      /> 
        <Hero
          heroBackground={midwesternHero}
          jobTitle={"Mobile Application Developer"}
          companyName={"Midwestern Interactive"}
          yearsActive={"2017 - 2020"}
        />
        <SingleAppShowCase
          backgroundColor={'#000'}
          addClass={'midwestern-background'}
          // appTitle={"CamoFlix"}
          appLogo={camoflixLogo}
          logoWidth={"45%"}
          lightText={true}
          extraPadding={'10%'}
          appDescription="CamoFlix is an online community built for the outdoor lover in all of us. 
                  Watch and upload hours of the highest quality content based around hunting and any other outdoor hobby you are into.
                  With a press of a button, you can get involved in the community forums, 
                  message your favorite content creators and edit your profile and subscriptions."
          appVisual={camoflix}
          appStoreLink="https://apps.apple.com/us/app/camoflix/id1434464573"
          googlePlayLink="https://play.google.com/store/apps/details?id=com.midwestern.camoflix&hl=en_US"
        />
        <SingleAppShowCase
          backgroundColor={'#000'}
          // appTitle={"LinerFinder"}
          appLogo={linerFinderLogo}
          addClass={'midwestern-background'}
          logoWidth={"50%"}
          lightText={true}
          extraPadding={'10%'}
          mirrored={true}
          appDescription="The Napco Bag App is made from the ground up to make the lives of Napco sales representatives 
                          and their superiors more efficient. This application grants the user the ability to submit a new quote by taking a 
                          photo in app or uploading a photo from their camera roll. On top of creating new quotes, 
                          managing existing quotes couldn't be any easier."
          appVisual={demo}
          appStoreLink="https://apps.apple.com/us/app/linerfinder/id1338562891"
        />
        <SingleAppShowCase
          backgroundColor={'#000'}
          // appTitle={"SELAH"}
          appLogo={SELAHLogo}
          addClass={'midwestern-background'}
          logoWidth={"30%"}
          lightText={true}
          extraPadding={'10%'}
          appDescription="SELAH is an app from CIY that allows christians to jump into meditative studies on the Bible 
                          through the use of text, audio and video."
          appVisual={selahsc}
          appStoreLink="https://apps.apple.com/us/app/selah-devos/id1383328814"
          googlePlayLink="https://play.google.com/store/apps/details?id=com.ciy.selah&hl=en_US&gl=US"
        />
      </div>
    );
  }
}

export default Midwestern;



// WEBPACK FOOTER //
// ./src/screens/Midwestern.js